<template>
    <div id="summary-controls-container" class="d-flex align-items-center gap-1">
        <Tooltip
            v-for="control in summaryControls" 
            :key="control.action + '.tooltip'"
            :title="control.tooltip"
            placement="bottom"
            tooltipClass="mt-1"
        >
            <button 
                :key="control.action"
                class="border-0 border-radius-8 bg-extra-light-purple min-h-26" 
                @click="handleClick(control.action)"
        >
            <component :is="'Icon' + control.icon" :size="control.size" :color="control.color"
                :hoverColor="control.hoverColor" />
            </button>
        </Tooltip>
    </div>
</template>

<script>
export default {
    props: {
        isEditing: {
            type: Boolean,
            default: false
        }
    },
    
    data() {
        return {
            summaryControls: [
                {
                    icon: 'TwoSquaresWithOverlappingCorners',
                    size: '14',
                    color: '#6260F0',
                    hoverColor: '#6260F0',
                    action: 'copy',
                    tooltip: this.__('Copiar'),
                },
                {
                    icon: 'TwoCurvedArrowsCircle',
                    size: '16',
                    color: '#6260F0',
                    hoverColor: '#6260F0',
                    action: 'retry',
                    tooltip: this.__('Refazer'),
                },
                {
                    icon: 'PencilFilled',
                    size: '12',
                    color: '#6260F0',
                    hoverColor: '#6260F0',
                    action: 'edit',
                    tooltip: this.__('Editar'),
                },
                {
                    icon: 'Close',
                    size: '10',
                    color: '#6260F0',
                    hoverColor: '#6260F0',
                    action: 'close',
                    tooltip: this.__('Descartar'),
                }
            ],
        }
    },

    watch: {
        isEditing: {
            handler() {
                const editControl = this.summaryControls.find(control => control.action === 'edit');
                if (editControl) {
                    editControl.icon = this.isEditing ? 'Check' : 'PencilFilled';
                }
            },
            immediate: true,
        }
    },

    methods: {
        handleClick(action) {
            this[action]();
        },

        copy() {
            const summarizedText = document.getElementById('summarized-text');
            if (summarizedText.type === 'textarea') {
                summarizedText.select();
                summarizedText.setSelectionRange(0, 99999);

                navigator.clipboard.writeText(summarizedText.value); 
            } else {
                navigator.clipboard.writeText(summarizedText.textContent);
            }

            this.displayCopyCheck();

            Alert.message(
                'success',
                this.__('Texto copiado com sucesso!'),
                'bottom-end',
                '',
                '',
                () => {},
                2000
            );
        },
        displayCopyCheck() {
            const copyControl = this.summaryControls.find(control => control.action === 'copy');
            if (!copyControl) {
                return;
            }

            copyControl.icon = 'Check';

            setTimeout(() => {
                copyControl.icon = 'TwoSquaresWithOverlappingCorners';
            }, 2000);
        },
        retry() {
            Bus.$emit('clickToSummarize');
        },  
        edit() {
            this.$emit('setIsEditing', !this.isEditing);
        },
        close() {
            this.$emit('discardSummary');
        }
    }
}
</script>


<style>
.bg-extra-light-purple {
    background-color: #F8F6FF;
}

.bg-extra-light-purple:hover {
    background-color: #FDE7FF;
}

.border-radius-8 {
    border-radius: 8px;
}

.min-h-26 {
    min-height: 26px;
}
</style>